import axios from 'axios'
import qs from 'qs'
import sign from './sign'
import { message } from 'ant-design-vue'

const instance = axios.create({
  timeout: 15000,
  withCredentials: false,
  baseURL: '/',
})

instance.defaults.headers['content-type'] = 'application/x-www-form-urlencoded'
instance.interceptors.request.use(
  (config) => {
    sign(config)
    if (config.url != '/api/cat/v1/ability/upload') {
      config.data = qs.stringify(config.data)
    }

    return config
  },
  (error) => {

    return Promise.reject(error)
  },
)

instance.interceptors.response.use(
  (res) => {
    if (res.status === 200 && res.data.code == 'success') {
      return res.data
    } else {
      return Promise.reject(res.data)
    }
  },
  (error) => {
    if (error?.message == 'Request failed with status code 401') {
      localStorage.removeItem('token')
      location.href = '/login'
    }
    return Promise.reject(error)
  },
)

function request(config = {}) {
  return new Promise((resolve, reject) => {
    instance
      .request(config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((error) => {
        if (error.code == 'ERR_BAD_RESPONSE') {
          message.error('服务器异常')
          return
        }
        reject(error)
      })
  })
}
export function post(url, data = {}, config = {}) {
  const conf = Object.assign({}, config, {
    method: 'post',
    url,
    data,
  })
  return request(conf)
}
export function get(url, params = {}, config = {}) {
  const conf = Object.assign({}, config, {
    method: 'get',
    url,
    params,
  })
  return request(conf)
}
export function put(url, data = {}, config = {}) {
  const conf = Object.assign({}, config, {
    method: 'put',
    url,
    data,
  })
  return request(conf)
}
export function del(url, params = {}, config = {}) {
  const conf = Object.assign({}, config, {
    method: 'delete',
    url,
    params,
  })
  return request(conf)
}

export function loginApi(data = {}) {
  return post('/api/cat/v1/auth/login', data)
}

export function exitApi(data = {}) {
  return post('/api/cat/v1/auth/login_out', data)
}
export function updatePassword(data = {}) {
  return post('/api/cat/v1/user/password', data)
}
export function statistic(){
  return post('/api/cat/v1/data/statistic')
}


export function upload(formData) {

  return post('/api/cat/v1/ability/upload',formData,{
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
//
export function getSysTime(){
  return post('/api/cat/v1/trade/control/cst')
}
